module.exports = __webpack_public_path__ + "img/invite_img.8599e862.svg";